// MyRIA
import { HttpClient, HttpClientModule } from '@angular/common/http';
//import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { AppVersion } from '@ionic-native/app-version';
import { Base64ToGallery } from '@ionic-native/base64-to-gallery';
import { Diagnostic } from '@ionic-native/diagnostic';
import { Globalization } from '@ionic-native/globalization';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { LocalNotifications } from '@ionic-native/local-notifications';
import { SocialSharing } from '@ionic-native/social-sharing';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { IonicStorageModule } from '@ionic/storage';
import { Contacts } from '@ionic-native/contacts';
//import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { IonicApp, IonicModule } from 'ionic-angular';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AccountProvider } from '../providers/myria/account-provider';
import { CustomersProvider } from '../providers/myria/customer-provider/customers-provider';
import { FormProvider } from '../providers/myria/form-provider';
import { HttpMapper } from '../providers/myria/http-mapper';
import { OnfidoProvider } from '../providers/myria/onfido-provider';
import { KYCProvider } from '../providers/myria/kyc-provider';
import { LoginProvider } from '../providers/myria/login-provider';
import { UtilsProvider } from '../providers/myria/utils-provider';
import { SharedPipesModule } from '../shared/shared-pipes.module';
import { MyApp } from './app.component';
import { AlertProvider } from '../providers/myria/alert-provider';
import { Keyboard } from '@ionic-native/keyboard';
import { CustomerProviderMapperProvider } from '../providers/myria/customer-provider/customer-provider-mapper';
import { LottieAnimationViewModule } from 'ng-lottie';
import { DatePipe } from '@angular/common'

// RMT
//import { StatusBar } from '@ionic-native/status-bar';
//import { SplashScreen } from '@ionic-native/splash-screen';
//import { BrowserModule } from '@angular/platform-browser';
//import { HttpClientModule, HttpClient } from '@angular/common/http';
//import { IonicStorageModule } from '@ionic/storage';
import { TranslateModule, TranslateLoader, MissingTranslationHandler, TranslateParser } from '@ngx-translate/core';
//import { IonicApp, IonicModule } from 'ionic-angular';
import { ErrorHandler, NgModule, Injector } from '@angular/core';
import { SecureStorage } from '@ionic-native/secure-storage';
import { Device } from '@ionic-native/device';
import { CallNumber } from '@ionic-native/call-number';
import { File } from '@ionic-native/file';
import { FileOpener } from '@ionic-native/file-opener';
//import { SocialSharing } from '@ionic-native/social-sharing';
import { EmailComposer } from '@ionic-native/email-composer';
//import { LottieAnimationViewModule } from 'ng-lottie';
import { Clipboard } from '@ionic-native/clipboard';

import { RecipientProvider } from '../providers/recipient/recipient';
import { StorageProvider } from '../providers/storage/storage';
import { DeviceProvider } from '../providers/device/device';
import { ScriptProvider } from '../providers/script/script';
import { WorldpayProvider } from '../providers/worldpay/worldpay';
import { PaymentProvider } from '../providers/payment/payment';
import { Songbird3dsBridgeProvider } from '../providers/payment/songbird-3ds-bridge';
import { PartnerCheckoutProvider } from '../providers/partner-checkout/partner-checkout';
import { DingTopUpProvider } from '../providers/ding-top-up/ding-top-up';
import { OrderProvider } from '../providers/order/order';
import { FormControlProvider } from '../providers/formbuilder/formcontrol';
import { VpaFormProvider } from '../providers/vpa-form/vpa-form';
import { AuthProvider } from '../providers/authorization/auth';
import { PageDirectoryProvider } from '../providers/page-directory/page-directory';
import { PriceCalculatorProvider } from '../providers/price-calculator/price-calculator';
import { RegisterProvider } from '../providers/register/register';
import { CountryDeclarationProvider } from '../providers/country-declaration/country-declaration';
import { DebugErrorProvider } from '../providers/debug-error/debug-error';
import { ReceiptProvider } from '../providers/receipt/receipt';
import { LocationProvider } from '../providers/location/location';
import { IdentityVerificationProvider } from '../providers/identity-verification/identity-verification';
import { DocumentVerificationProvider } from '../providers/document-verification/document-verification';
import { SystemProvider } from '../providers/system/system';
import { BranchProvider } from '../providers/analytics/branch';
import { NotificationProvider } from '../providers/notification/notification';
import { GlobalErrorHandler } from '../providers/error/error-handler';
import { HttpLoaderFactory, TranslationFallbackHandler, TranslationParserHandler } from '../translations';
//import { MyApp } from './app.component';
import { ComponentsModule } from '../components/components.module';
import { PreLoginStoriesPageModule } from '../pages/pre-login-stories/pre-login-stories.module';
import { PreLoginStoriesPage } from '../pages/pre-login-stories/pre-login-stories';
import { HTTP } from '@ionic-native/http';
//import { AppVersion } from '@ionic-native/app-version';
//import { InAppBrowser } from '@ionic-native/in-app-browser';
import { Geolocation } from '@ionic-native/geolocation';
//import { Globalization } from '@ionic-native/globalization';
import { PipesModule } from '../pipes/pipes.module';
import { HttpProvider } from '../providers/http/http';
import { LoadingProvider } from '../providers/loading/loading';
import { RouteProvider } from '../providers/route/route';
import { ResourceProvider } from '../providers/resource/resource';
import { AgentProvider } from '../providers/agent/agent';
import { SendFlowProvider } from '../providers/send-flow/send-flow';
import { LoggerProvider } from '../providers/logger/logger';
import { CustomerProvider } from '../providers/customer/customer';
import { MarketingProvider } from '../providers/marketing/marketing';
import { ConfigProvider } from '../providers/config/config';
import { CallProvider } from '../providers/call/call';
import { SegmentProvider } from '../providers/analytics/segment';
import { KeychainTouchId } from '@ionic-native/keychain-touch-id';
import { OpenNativeSettings } from "@ionic-native/open-native-settings";
import { IterableProvider } from '../providers/marketing/iterable';
import { IovationProvider } from '../providers/iovation/iovation';
import { SocialProvider } from '../providers/social/social';
import { DuitNowQrShareProvider } from '../providers/duitnow-qr-share/duitnow-qr-share';
import { CardProvider } from '../providers/card/card';
import { DeeplinkProvider } from '../providers/marketing/deeplink';
import { PlaidProvider } from '../providers/plaid/plaid';
import { LogRocketProvider } from '../providers/log-rocket/log-rocket';
import { InternalIssueReportProvider } from '../providers/internal-issue-report/internal-issue-report';
import { MobileWalletProvider } from '../providers/mobile-wallet/mobile-wallet-provider';
import { BankDepositSmartRoutingProvider } from '../providers/bank-deposit-smart-routing/bank-deposit-smart-routing';
import { DeliveryMethodAvailabilityProvider } from '../providers/delivery-method-availability/delivery-method-availability';
import { HelpProvider } from '../providers/help/help';
import { CancellationReasonProvider } from '../providers/cancellation-reasons/cancellation-reason';
import { PermissionProvider } from '../providers/myria/permission-provider';
import { ForeignIpGeolocationProvider } from '../providers/foreign-ip-geolocation/foreign-ip-geolocation';

import { Camera } from '@ionic-native/camera';//import in app.module.ts
import { Chooser } from '@ionic-native/chooser';
import { IOSFilePicker } from '@ionic-native/file-picker';
import { WalletProvider } from '../providers/wallet/wallet';
import { AppVersionProvider } from '../providers/app-version/app-version';
import { SafariViewController } from '@ionic-native/safari-view-controller';
import { FirebaseAnalyticsProvider } from '../providers/analytics/firebase-analytics';
import { DocUploadProvider } from '../providers/doc-upload/doc-upload';
import { IterableInAppProvider } from '../providers/marketing/iterable-inapp';
import { UploadProvider } from '../providers/upload/upload';
import { Base64 } from '@ionic-native/base64';
import { FilePath } from '@ionic-native/file-path';
import { CurrencyPipe } from '@angular/common';
import { FintocProvider } from '../providers/fintoc/send-pay-fintoc';
import { SendOpenBankingProvider } from '../providers/openbanking/send-openbanking';
import { PromoProvider } from '../providers/promo/promo';
import { NumberFormatter } from '../pipes/currency-pipe';
import { RmtSnackbarComponent } from '../components/rmt-snackbar/rmt-snackbar';
import { ColorProvider } from '../providers/color/color';
import { WalletCardProvider } from '../providers/wallet/wallet-card';
import { RSAEncryptnProvider } from '../providers/rsa-encrypt/rsa-encrypt'
import { ContactsProvider } from '../providers/contacts/contacts';
import { ProfileNotificationProvider } from '../providers/profile-notification/profile-notification';
import { ZendeskSupportProvider } from '../providers/zendesk/zendesk-support';
import { KeyboardProvider } from '../providers/keyboard/keyboard';
import { TalsecProvider } from '../providers/talsec/talsec';
import { WalletServicesProvider } from '../providers/wallet-services/wallet-services';
import { QrcodescannerProvider } from '../providers/qrcodescanner/qrcodescanner';
import { SendAgainProvider } from '../providers/send-again/send-again';
import { CommonProvider } from '../providers/common/common';
import { ChatProvider } from '../providers/zendesk/chat';
import { EkycSingPassProvider } from '../providers/ekyc-singpass/ekyc-singpass';
import { HomeScreenProvider } from '../providers/homescreen/homescreen';
import { APIGuardProvider } from '../providers/http/api-guard';
import { LaunchNavigator } from '@awesome-cordova-plugins/launch-navigator/ngx';
import { AdditionalDetailsProvider } from '../providers/send-flow/additional-details'; // Adjust the path as needed
import { ReminderProvider } from '../providers/reminder-provider/reminder-provider';
import { VueProvider } from '../providers/vue/vue';
import { VueBranchProvider } from '../providers/vue/vue-branch';
import { NativeProvider } from '../providers/native/native';
import { NativeLiquidGlassBarProvider } from '../providers/native/native-liquid-glass-bar';
import { NativeBiometricsProvider } from '../providers/native/native-biometrics';

import { AdyenPlugin } from '../providers/adyen/adyen-sdk';
import { TrueLayerPlugin } from '../providers/truelayer/truelayer-sdk';
import { Worldpay3dsPlugin } from '../providers/worldpay/worldpay-3ds-sdk';
import { PhoneProvider } from '../providers/phone/phone';
import { OtpTimerProvider } from '../providers/otp-timer/otp-timer';
import { LoqateProvider } from '../providers/loqate/loqate-provider';
// get a reference to the root injector
export let injectorInstance: Injector;

@NgModule({
  declarations: [MyApp],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    IonicModule.forRoot(MyApp, {
      backButtonText: '',
      scrollAssist: false,
      scrollPadding: false,
      autoFocusAssist: 'immediate',
    }),
    IonicStorageModule.forRoot({
      name: 'ria-mobile',
      driverOrder: ['indexeddb', 'sqlite', 'websql'],
    }),
    PipesModule,
    ComponentsModule,
    HttpClientModule,
    TranslateModule.forRoot({
      missingTranslationHandler: { provide: MissingTranslationHandler, useClass: TranslationFallbackHandler },
      parser: {provide: TranslateParser, useClass: TranslationParserHandler},
      useDefaultLang: true,
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    SharedPipesModule,
    PreLoginStoriesPageModule,
    LottieAnimationViewModule.forRoot(),
  ],
  bootstrap: [IonicApp],
  entryComponents: [MyApp, PreLoginStoriesPage],
  providers: [
    // MyRIA
    SocialSharing,
    Diagnostic,
    InAppBrowser,
    SplashScreen,
    KeychainTouchId,
    OpenNativeSettings,
    LocalNotifications,
    StatusBar,
    Globalization,
    AppVersion,
    FormsModule,
    LoginProvider,
    HttpMapper,
    UtilsProvider,
    FormProvider,
    CustomersProvider,
    AccountProvider,
    KYCProvider,
    OnfidoProvider,
    Base64ToGallery,
    AlertProvider,
    Keyboard,
    CustomerProviderMapperProvider,
    Contacts,
    CurrencyPipe,
    NumberFormatter,
    DatePipe,

    // RMT
    //StatusBar,
    //SplashScreen,
    SecureStorage,
    Device,
    CallNumber,
    HTTP,
    File,
    FileOpener,
    //AppVersion,
    //InAppBrowser,
    Geolocation,
    //Globalization,
    //SocialSharing,
    EmailComposer,
    Clipboard,
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    RecipientProvider,
    CustomerProvider,
    StorageProvider,
    DeviceProvider,
    ScriptProvider,
    WorldpayProvider,
    PaymentProvider,
    Songbird3dsBridgeProvider,
    PartnerCheckoutProvider,
    DingTopUpProvider,
    OrderProvider,
    FormControlProvider,
    VpaFormProvider,
    AuthProvider,
    PageDirectoryProvider,
    PriceCalculatorProvider,
    RegisterProvider,
    CountryDeclarationProvider,
    DebugErrorProvider,
    ReceiptProvider,
    LocationProvider,
    IdentityVerificationProvider,
    DocumentVerificationProvider,
    SystemProvider,
    BranchProvider,
    NotificationProvider,
    HttpProvider,
    LoadingProvider,
    RouteProvider,
    ResourceProvider,
    AgentProvider,
    SendFlowProvider,
    LoggerProvider,
    MarketingProvider,
    ConfigProvider,
    CallProvider,
    ChatProvider,
    SegmentProvider,
    OnfidoProvider,
    IterableProvider,
    IovationProvider,
    SocialProvider,
    DuitNowQrShareProvider,
    CardProvider,
    DeeplinkProvider,
    PlaidProvider,
    LogRocketProvider,
    InternalIssueReportProvider,
    MobileWalletProvider,
    BankDepositSmartRoutingProvider,
    DeliveryMethodAvailabilityProvider,
    HelpProvider,
    CancellationReasonProvider,
    WalletProvider,
    AppVersionProvider,
    SafariViewController,
    FirebaseAnalyticsProvider,
    DocUploadProvider,
    IterableInAppProvider,
    Camera,
    UploadProvider,
    Chooser,
    FilePath,
    IOSFilePicker,
    Base64,
    FintocProvider,
    SendOpenBankingProvider,
    PromoProvider,
    ColorProvider,
    WalletCardProvider,
    RSAEncryptnProvider,
    ContactsProvider,
    ProfileNotificationProvider,
    ZendeskSupportProvider,
    KeyboardProvider,
    TalsecProvider,
    WalletServicesProvider,
    QrcodescannerProvider,
    SendAgainProvider,
    CommonProvider,
    EkycSingPassProvider,
    HomeScreenProvider,
    APIGuardProvider,
    LaunchNavigator,
    AdditionalDetailsProvider,
    ReminderProvider,
    VueProvider,
    VueBranchProvider,
    NativeProvider,
    NativeLiquidGlassBarProvider,
    NativeBiometricsProvider,
    PermissionProvider,
    ForeignIpGeolocationProvider,
    AdyenPlugin,
    TrueLayerPlugin,
    Worldpay3dsPlugin,
    PhoneProvider,
    OtpTimerProvider,
    LoqateProvider,
  ],
})
export class AppModule {
  constructor(private injector: Injector) {
    // leverage the DI framework for manual use later
    injectorInstance = this.injector;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts